// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.progress-container[data-v-0525a09e] {\n\tmax-width: 300px;\n\twidth:100%;\n\ttext-align: center;\n}\n.progress-text[data-v-0525a09e] {\n\tfont-size: 14pt;\n\tcolor: var(--main-gray-6);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
